export default "__VITE_ASSET__BJ4SNrR6__"